import { VISA_TYPES } from './constants';
import type { PackageVisaStateType } from './types';

const validateVisaTypes = (
  type: string,
): (typeof VISA_TYPES)[keyof typeof VISA_TYPES] => {
  if (Object.values<string>(VISA_TYPES).includes(type)) {
    return type as (typeof VISA_TYPES)[keyof typeof VISA_TYPES];
  }
  return VISA_TYPES.NO_VISA;
};

export const visaDTO = (visa: unknown): PackageVisaStateType => {
  if (visa && typeof visa === 'object') {
    return {
      price: 'price' in visa && typeof visa.price === 'number' ? visa.price : 0,
      docPrice:
        'docs_price' in visa && typeof visa.docs_price === 'number'
          ? visa.docs_price
          : 0,
      policy:
        'policy' in visa && typeof visa.policy === 'string'
          ? visa.policy
          : null,
      text: 'text' in visa && typeof visa.text === 'string' ? visa.text : null,
      rules:
        'rules' in visa && typeof visa.rules === 'string' ? visa.rules : null,
      type:
        'type' in visa && typeof visa.type === 'string'
          ? validateVisaTypes(visa.type)
          : VISA_TYPES.NO_VISA,
      purchasable:
        'purchasable' in visa && typeof visa.purchasable === 'boolean'
          ? visa.purchasable
          : null,
    };
  }
  return {
    price: 0,
    docPrice: 0,
    policy: null,
    text: null,
    rules: null,
    type: VISA_TYPES.NO_VISA,
    purchasable: null,
  };
};
